import React, { useState } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import { ButtonClose } from "@lk-gtcom/ecomlab-components";
import { TextPage } from '../../../../../components/TextPage/TextPage';
import { usePushNotifications } from '../../../../../common/pushNotification';
import './CardContract.scss'

interface CardContractProps {
    name: string
    unit: string
    active: string
    record_id: string
    price_unit: string
    amount_unit: string
    need_report: string
    payment_part: string
    payment_type: string
    payment_period: string
    additional_fields: string
    service_id: string
    comment: string
    invoice_name: string
    fetchDeleteServices: (id: string) => void
    setCurrentCustomService: (data: {}) => void
    setIsModaCustomServices: (e: boolean) => void
}

const CardContract = ({
    name,
    unit,
    active,
    record_id,
    price_unit,
    amount_unit,
    need_report,
    payment_part,
    payment_type,
    payment_period,
    additional_fields,
    service_id,
    comment,
    invoice_name,
    fetchDeleteServices,
    setCurrentCustomService,
    setIsModaCustomServices
}: CardContractProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    // Обработка ошибок
    const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

    const handleCardClick = () => {
        const data = {
            name,
            unit,
            active,
            record_id,
            price_unit,
            amount_unit,
            need_report,
            payment_part,
            payment_type,
            payment_period,
            additional_fields,
            service_id,
            comment,
            invoice_name
        }
        setCurrentCustomService(data);
        setIsModaCustomServices(true);
    };

    const toggleExpand = (e: React.MouseEvent) => {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        fetchDeleteServices(record_id);
    };

    return (
        <div className='card-contract'>
            <div className='card-contract__header'>
                <div 
                    className='card-contract__title-section'
                    onClick={toggleExpand}
                >
                    <div className='card-contract__title'>
                        <span className='card-contract__label'>Наименование: </span>
                        <span className='card-contract__value'>{name || '-'}</span>
                    </div>
                    <button 
                        className='card-contract__toggle'
                        onClick={toggleExpand}
                        aria-label={isExpanded ? 'Свернуть' : 'Развернуть'}
                    >
                        {isExpanded ? '▲' : '▼'}
                    </button>
                </div>
                
                <ButtonClose
                    xs
                    onClick={handleDelete}
                    className='card-contract__delete-btn'
                />
            </div>

            {isExpanded && (
                <div 
                    className='card-contract__content'
                    onClick={handleCardClick}
                >
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Юридическое название: </span>{invoice_name || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Активно: </span>{active ? 'Да' : 'Нет'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Всего: </span>{unit || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Цена: </span>{price_unit || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Ед.: </span>{unit || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Ед. суммы: </span>{amount_unit || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Требуется отчет: </span>{need_report ? 'Да' : 'Нет'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Способ оплаты: </span>{payment_part || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Тип оплаты: </span>{payment_type || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Период оплаты: </span>{payment_period || '-'}</>}
                    />
                    <TextPage
                        text={<><span style={{ color: '#888', fontSize: '12px' }}>Комментарии: </span>{comment || '-'}</>}
                    />
                </div>
            )}
        </div>
    )
}

export { CardContract }